<template>
  <div>
<!--    商家评分-->
    <div class="flex_center evaluate__storeGrade" v-if="store_id">
      <div class="storeGrade__left">
        <p>{{avg_data.store_level_avg}}</p>
        <div>商家评分</div>
      </div>
      <div class="storeGrade__right">
        <p class="flex_center">
          <span>环境</span>
          <van-rate v-model="avg_data.store_environment_level_avg" allow-half void-icon="star" void-color="#eee" size="13px" gutter="5px" readonly />
          <span class="col_F9CE06">{{avg_data.store_environment_level_avg}}</span>
        </p>
        <p class="flex_center">
          <span>服务</span>
          <van-rate v-model="avg_data.store_service_level_avg" allow-half void-icon="star" void-color="#eee" size="13px" gutter="5px" readonly />
          <span class="col_F9CE06">{{avg_data.store_service_level_avg}}</span>
        </p>
      </div>
    </div>

    <div class="flex_center evaluate__storeGrade" v-else>
      <div class="storeGrade__left">
        <p>{{avg_data.tech.score}}</p>
        <div>技师评分</div>
      </div>
      <div class="storeGrade__right">
        <p class="flex_center">
          <span>服务</span>
          <van-rate v-model="avg_data.tech_service_level_avg" allow-half void-icon="star" void-color="#eee" size="13px" gutter="5px" readonly />
          <span class="col_F9CE06">{{avg_data.tech_service_level_avg}}</span>
        </p>
        <p class="flex_center">
          <span>手法</span>
          <van-rate v-model="avg_data.tech_technique_level_avg" allow-half void-icon="star" void-color="#eee" size="13px" gutter="5px" readonly />
          <span class="col_F9CE06">{{avg_data.tech_technique_level_avg}}</span>
        </p>
      </div>
    </div>

<!--    评价内容-->
    <van-tabs v-model="type" @click="change_type()" sticky line-height="0px">
      <van-tab v-for="(tabItem,tabIndex) in tabList" :key="tabIndex">
        <!--评价标题项-->
        <div slot="title" class="evaluate__tabTitle">
          {{tabItem.title}}({{tabItem.num}})
        </div>
        <!--评价列表-->
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="comment__list" v-for="(item,index) in tabItem.list" :key="index">
            <div class="comment__list_card">
              <div><img :src="item.headimgurl" alt=""></div>
              <div class="comment__card_content">
                <div class="flex"><span>{{item.nickname}}</span><span class="fs_12 col_999">{{item.createtime}}</span></div>
                <van-rate v-model="item.store_level" allow-half void-icon="star" void-color="#eee" size="11px" gutter="2px" readonly  v-if="store_id"/>
                <van-rate v-model="item.tech_level" allow-half void-icon="star" void-color="#eee" size="11px" gutter="2px" readonly  v-else/>
              </div>
            </div>
            <div class="comment__list_details">
              <p class="comment__list_text">{{item.content?item.content:'该用户没有评论'}}</p>
              <div class="comment__list_imgBox" >
                <img :src="imgItem" alt="" v-for="(imgItem,imgIndex) in item.images" :key="imgIndex" @click="previewImg(item.images, index)">
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  import { ImagePreview } from 'vant';  //图片预览

  export default {
    name: "evaluate",
    data() {
      return {
        environment_value: 4.5,  //环境评星
        serve_value: 4,    //服务评星
        avg_data:[],//评分
        active:0,  
        ImagePreviewDialog:'',   //预览图片
        loading: false,
        finished: false,
        type:0,//tab当前所在位置
        store_id:0,
        tech_id:0,
        store:[],
        tech:[],  
        page:0,     
        // 评价内容
        tabList:[
          {
          title:'全部',
          num:0,
          list:[]
          },{
          title:'好评',
          num:0,
          list:[]
          }, {
            title: '中评',
            num: 0,
            list: []
          },{
            title: '差评',
            num: 0,
            list: [],
          }
        ]
      }
    },
    // 在 beforeRouteLeave 钩子中调用 close() 方法关闭预览遮罩
    beforeRouteLeave(to,from,next){ // 解决ImagePreview图片预览路由切换不隐藏的问题
      this.ImagePreviewDialog&&this.ImagePreviewDialog.close();
      next()
    },
    methods:{
      // 预览图片
      previewImg(imgs, index){
        this.ImagePreviewDialog = ImagePreview({
          images: imgs,
          startPosition: index
        })
      },
      get_comment(){
         this.axios({
          url: this.api.member.comment,
          data:{
            type:this.type,
            store_id:this.store_id,
            tech_id:this.tech_id,
            page:this.page
          }
        }).then((res) => {
            if (res.error === 0) {
              this.avg_data  = res.avg_data
              this.tabList[0].num = res.all_comment_num
              this.tabList[1].num= res.good_comment_num
              this.tabList[2].num= res.secondary_comment_num
              this.tabList[3].num = res.bad_comment_num
              this.page = parseInt(res.page)
              // this.tabList[this.type].list = res.comment_list
              for(let i=0;i<res.comment_list.length;i++){
                this.tabList[this.type].list.push(res.comment_list[i]);
              }
              
              if(res.comment_list.length>0){
                  this.order_none = 1
              }
              this.loading = false
              if ( this.tabList[this.type].list.length >= this.tabList[this.type].num) {
                this.finished = true
              }
            }

        })
      },
      // 加载数据
      onLoad() {
        console.log(this.type);
        // 异步更新数据
        setTimeout(() => {
          // 定义当前所在的数组
          var tabList_active=this.tabList[this.type];
          // 定义一个变量，取出当前数组的里的list
          var list=tabList_active['list'];
          
          // 加载状态结束
           this.loading = false
           if ( list.length >= this.tabList[this.type].num) {
             this.finished = true
          }else{
              this.page =this.page+1;         
             this.get_comment();
          }
         
        }, 500);
      },
      change_type(){
          this.page = 0;
          this.finished= false;
          this.loading = true;
          this.tabList[this.type].list= [];  
          this.get_comment();
      },
    },
    created(){
      this.store_id =  this.$route.query.store_id;
      this.tech_id =  this.$route.query.tech_id;
      this.get_comment();
    }
  }
</script>

<style scoped>
  .evaluate__storeGrade{
    background: #fff;
    margin-bottom: .5rem;
    padding: .75rem;
    font-size: .6rem;
    color: #999;
  }
  .storeGrade__left{
    text-align: center;
    padding: 0 1.75rem 0 .75rem;
  }
  .storeGrade__left>p{
    color: #45B9BC;
    font-size: 1.2rem;
  }
  .storeGrade__right>p{
    margin: .1rem 0;
  }
  .storeGrade__right .van-rate{
    margin: 0 .35rem;
  }
  /*评价标题项*/
  .evaluate__tabTitle{
    color: #999;
    border: 1px solid #ccc;
    line-height: 1.2rem;
    margin: .45rem .1rem;
    border-radius: 1.2rem;
    font-size: .6rem;
  }
  .van-tab--active .evaluate__tabTitle{
    color: #45B9BC;
    border-color: rgba(69, 185, 188, .5);
  }
  /*评论列表*/
  .comment__list{
    padding: .25rem .75rem 0;
    background: #fff;
    font-size: .7rem;
    color: #333;
    border-bottom: 1px solid rgba(231,231,231,.5);
  }
  .comment__list:last-child{
    border: 0;
  }
  .comment__list_card{
    display: flex;
    padding: .5rem 0;
    align-items: center;
  }
  .comment__list_card img{
    width: 2rem;
    height: 2rem;
    margin-right: .5rem;
    border-radius: 50%;
    border: 1px solid rgba(231,231,231,.5);
  }
  .comment__card_content{
    width: 100%;
  }
  .comment__list_details{
    margin-left: 2.5rem;
    padding-bottom: .25rem;
    margin-top: -.25rem;
  }
  .comment__list_text{
    font-size: .65rem;
    color: #666;
    margin-bottom: .5rem;
  }
  .comment__list_imgBox{
    overflow: hidden;
    margin-right: -3.33%;
  }
  .comment__list_imgBox img{
    width: 30%;
    margin: 0 3.33% .5rem 0;
    float: left;
    height: 4rem;
  }


</style>



// WEBPACK FOOTER //
// src/views/book/evaluate.vue